import { ITurnOverTable, TotalizadoresTurnOver } from "services/NGT/EffectiveConsolidation"

import { FormatNumber } from "../../Shared/FormatNumber"

export class FormatTableData {

  static formatarNumero(numero: number) {
    return FormatNumber.formatarNumero(numero);
  }

  static formatarTableData(tableData: ITurnOverTable) {
    if (tableData) {
      tableData.itensConsolidacao.map(
        (item) => (item.totalizadores = this.mapTableDataItem(item.totalizadores))
      )
    }
  }
  static formatarSubItens(tableData: ITurnOverTable) {
    if (tableData) {
      tableData.itensConsolidacao.map(
        (item) =>
          (item.itens = item.itens.map((subitem) => this.mapTableDataItem(subitem)))
      )
    }
  }

  static mapTableDataItem(item: TotalizadoresTurnOver) {
    return {
      acesso: this.formatarNumero(item.acesso) as unknown as number,
      afastado: this.formatarNumero(item.afastado) as unknown as number,
      ativo: this.formatarNumero(item.ativo) as unknown as number,
      compartilhado: this.formatarNumero(item.compartilhado) as unknown as number,
      demitido: this.formatarNumero(item.demitido) as unknown as number,
      dsConsolidacao: item.dsConsolidacao,
      idConsolidacao: this.formatarNumero(item.idConsolidacao) as unknown as number,
      idUnidadeGestora: this.formatarNumero(item.idUnidadeGestora) as unknown as number,
      nmUnidade: item.nmUnidade,
      qtTotalSemDemitido: this.formatarNumero(item.qtTotalSemDemitido) as unknown as number,
      totalEfetivo: this.formatarNumero(item.totalEfetivo) as unknown as number,
      transferido: this.formatarNumero(item.transferido) as unknown as number,
      turnOver: this.formatarNumero(item.turnOver) as unknown as number
    }
  }
}
